import React, {PureComponent, ReactNode} from "react";
import {Brand} from "@App/types";
import {Text} from "@eo-locale/react";

export type GarageListItemBrandIconsProps = {
    brands: Brand[],
};

class GarageListItemBrandIcons extends PureComponent<GarageListItemBrandIconsProps> {

    render(): ReactNode {
        const {
            brands
        } = this.props

        return (
            <div className={"garageListItem__brandIcons"}>
                {brands.map((brand: Brand) => (
                    <i key={brand.id} className={`fa-kit fa-fw text-gray-700 fa-${brand.icon.replace('fa-', '')} text-2xl mr-2`}></i>
                ))}
                <span className={'garageListItem__brandIcons__garageText'}><Text id={'authorized_garage'}/></span>
            </div>
        );
    }
}

export default GarageListItemBrandIcons